import { useTranslation } from 'next-i18next'

import CloseButtonIcon from '~/components/Icons/svgs/CloseButtonIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import { selectMenuCurriculumDropdownExpanded } from '~/curriculum/slice/curriculum.slice'
import { useAppSelector } from '~/redux/hooks'
import { selectMenuIsExpanded } from '~/redux/slices/menu'

import useHandleAndLogToggleMenu from '../hooks/useHandleAndLogToggleMenu'

import MenuContent from './MenuContent'

const MenuOverlay = ({ isDonationLayout = false }): React.ReactElement => {
  const { t } = useTranslation('menu')
  const isMenuOpen = useAppSelector(selectMenuIsExpanded)
  const isCurriculumDropdownExpanded = useAppSelector(selectMenuCurriculumDropdownExpanded)
  const closeMenuHandler = useHandleAndLogToggleMenu()
  // The curriculum dropdown hangs below the panel (per design), so clipping must be lifted while
  // it is expanded; overflow-hidden is restored on close so the max-height animation still clips
  const allowDropdownOverflow = isMenuOpen && isCurriculumDropdownExpanded

  return (
    <div
      className={`${
        isDonationLayout ? 'top-14' : 'top-13'
      } w-full absolute -z-10 left-0 md:top-16 md:shadow rounded-b-4 ${allowDropdownOverflow ? '' : 'overflow-hidden'}`}
      style={{
        transition: `max-height 500ms cubic-bezier(0.4, 0, 1, 1)`,
        // must exceed the tallest possible panel: the mobile panel is in-flow (no inner scroller),
        // so a fully "Vis mer"-expanded admin menu is the real height, not one viewport
        maxHeight: isMenuOpen ? '3000px' : 0,
      }}
    >
      <div
        className={`relative w-full rounded-b-4 border-2 border-purple-lilac-fade bg-purple-abyss ${
          allowDropdownOverflow ? '' : 'overflow-hidden'
        }`}
      >
        <button
          aria-label={t('toggleNavigationMenu')}
          className="absolute right-4 top-4 z-10"
          data-test-id="menu-close"
          onClick={closeMenuHandler}
        >
          <SVGIcon icon={CloseButtonIcon} pathClassName="text-white" size={24} />
        </button>
        <MenuContent />
      </div>
    </div>
  )
}

export default MenuOverlay
